import { render, staticRenderFns } from "./AllBookTopicItems.vue?vue&type=template&id=c89c132a"
import script from "./AllBookTopicItems.vue?vue&type=script&lang=js"
export * from "./AllBookTopicItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports